import styled from 'styled-components';
import { color } from 'theme';

export const StyledSection = styled.div`
  background-color: ${color('sand_100')};
`;
